import { Avatar, Grid, List, ListItem, ListItemAvatar, ListItemText } from "@mui/material"

const SkillsList = ({ data }: {
    data: {
        id: number, name: string, icon: React.FunctionComponent<React.SVGProps<SVGSVGElement> & {
            title?: string;
        }>
    }[]
}) => {
    return (
        <List>
            <Grid container spacing={2}>
                {data.map(element => (
                    <Grid size="auto">
                        <ListItem>
                            <ListItemAvatar>
                                <Avatar>
                                    <element.icon />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                secondary={element.name}
                            />
                        </ListItem>
                    </Grid>
                ))}
            </Grid>
        </List>
    )
}

export default SkillsList